'use client';

import type { ReactNode, RefObject } from 'react';

import Modal, { type ModalProps } from '@/app/Components/Modal';
import Sheet from '@/app/Components/Sheet';

type DegreePlanningModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  size?: ModalProps['size'];
  initialFocusRef?: RefObject<HTMLElement | null>;
};

/** Route-owned composition that keeps every degree-planning dialog on canonical transient anatomy. */
export function DegreePlanningModal({
  isOpen,
  onClose,
  title,
  children,
  size = 'lg',
  initialFocusRef,
}: DegreePlanningModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      initialFocusRef={initialFocusRef}
      closeOnOverlayClick={false}
    >
      {children}
    </Modal>
  );
}

type DegreePlanningRequirementsSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

/** The requirement inspector is spatially anchored to the workspace edge, so it remains a right Sheet. */
export function DegreePlanningRequirementsSheet({ isOpen, onClose, children }: DegreePlanningRequirementsSheetProps) {
  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      title="Plan Requirements"
      side="right"
      closeOnOverlayClick
    >
      {children}
    </Sheet>
  );
}
